export const environment = {
  production: true,
  APIEndPoint: "https://api.dtechgrp.com/",
};
